import React from 'react';
import Box from 'sail/Box';
import {Title, Text} from 'sail/Text';
import Step from './Step';
import {useContent} from '../../data/ContentProvider';
import {useGuide} from '../../data/GuideProvider';
import '../../css/Steps.scss';
import {FormattedMessageOrString} from '../../../../data/localization/intlUtils';

export default function StepList({section, index}) {
  const sectionNumber = index + 1;
  const {steps} = useContent();
  const {options} = useGuide();
  if (!steps) {
    return null;
  }

  // Get steps for each section and filter out any steps that don't match the user-selected options
  const sectionSteps = steps.filter(
    (step) =>
      step.section === section.id &&
      !step.extensionId &&
      (!step.filter || step.filter(options)),
  ) || [{}];

  return (
    <Box className="StepList" padding={{bottom: 48}}>
      <Box
        flex={{alignItems: 'center'}}
        margin={{horizontal: 32}}
        padding={{bottom: 20}}
      >
        <Text
          style={{
            width: '16px',
            height: '16px',
            background: 'var(--sail-color-gray-300)',
            borderRadius: '50%',
            fontSize: '11px',
            fontWeight: 700,
            color: '#fff',
            marginRight: '8px',
            textAlign: 'center',
            lineHeight: '16px',
          }}
        >
          {sectionNumber}
        </Text>
        <Title
          style={{
            zIndex: 100,
            fontWeight: 700,
          }}
          color="dark"
        >
          <FormattedMessageOrString stringOrDefineMessage={section.heading} />
        </Title>
      </Box>
      {/* Render each step in the section */}
      {sectionSteps.map((s, i) => (
        <Step key={`step=${i}`} step={s} index={i} />
      ))}
    </Box>
  );
}
